import { useDataChange } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow'

export function useOnCancelClick(props) {
  let setFlow = useSetFlowTo(props.viewPath)
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'question_id',
  })

  return function onCancel() {
    change(null)

    setFlow(normalizePath(props.viewPath, '../../../No'))
  }
}
